'use client';

import React from 'react';

import { LoginForm } from '@/components';

interface LoginModalProps {
  isShowing: boolean;
  onLoggedIn: () => void;
}

export function LoginModal({ isShowing, onLoggedIn }: LoginModalProps) {
  return (
    isShowing && (
      <LoginForm
        onLoggedIn={onLoggedIn}
        showInterimStates={false}
      />
    )
  );
}
